import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import "@/index.css";
import App from "@/App";

// Fix ResizeObserver loop error - patch before anything else loads
// This is a known browser issue with ResizeObserver that doesn't affect functionality
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

// Suppress ResizeObserver error in error handlers
const errorHandler = (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return true;
  }
};
window.addEventListener('error', errorHandler, true);

// Register service worker with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered:', registration.scope);
        
        // Check for updates periodically (every 30 min)
        setInterval(() => registration.update(), 30 * 60 * 1000);
        
        // Detect when a new SW is waiting (update available)
        const showUpdateNotification = () => {
          // Dispatch event so App can show an update banner
          window.dispatchEvent(new CustomEvent('swUpdateAvailable', { detail: { registration } }));
        };

        if (registration.waiting) {
          showUpdateNotification();
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW installed but old one still controls - update available
              showUpdateNotification();
            }
          });
        });

        // When a new SW takes over via UPDATE, reload the page once.
        // Skip reload on first install (no previous controller).
        const hadController = !!navigator.serviceWorker.controller;
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (hadController && !refreshing) {
            refreshing = true;
            window.location.reload();
          }
        });
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
